import { Body, Card, getImgProps, Heading, Img, TextVerticalSpacer } from '@superhi/design'
import React, { useMemo } from 'react'

import { buildPath } from 'src/routing'

type Props = {
  title: string
  description: string
  imageUrl: string
  imageAlt: string
  courseTitle: string
  courseSlug: string
}

const CourseProjectCard: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  description,
  imageUrl,
  imageAlt,
  courseTitle,
  courseSlug,
}) => {
  const imageProps = useMemo(
    () =>
      getImgProps(
        imageUrl,
        {
          small: 80,
          medium: 45,
          large: 25,
          xlarge: 20,
        },
        {
          fm: 'png8',
        },
      ),
    [imageUrl],
  )
  const href = useMemo(
    () => buildPath('courses-view', { params: { slug: courseSlug } }),
    [courseSlug],
  )

  return (
    <Card
      href={href}
      header={<Img {...imageProps} alt={imageAlt} aspectRatio="16:9" fit="cover" />}
    >
      <TextVerticalSpacer level="4">
        <Heading level="5" color="GREY_90" as="h3">
          {title}
        </Heading>

        <Body level="3" color="GREY_70">
          with {courseTitle}
        </Body>

        <Body level="3" color="GREY_90">
          {description}
        </Body>
      </TextVerticalSpacer>
    </Card>
  )
}

export default CourseProjectCard
